import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';



interface AdressListProp {
  list: AddressListEntry[];
}

export interface AddressListEntry {
  adress_id: number;

  gender: string;
  company: string;
  firstname: string;
  lastname: string;
  stret: string;
  house_number: string;
  postcode: string;
  city: string;
  department: string;
  additive1: string;
  additive2: string;
  country_id: number;
  country_name: string;
  iso_code_2: string;
  isShippingDefault: boolean;
  isBillingDefault: boolean;
}

export default class AdressList extends React.Component<AdressListProp> {
  render(): React.ReactNode {
    return (
      <div id="addressList">
        <table className="adressTable">
          <thead>
            <tr key={'adress_header'}>
              <th>Name</th>
              <th>Straße</th>
              <th>Ort</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.props.list.map((item, index) => {
              return (
                <>
                  <tr
                    key={'adress_pos' + index}
                    id={'adress_pos' + index}
                    className={'row' + (index % 2 == 1 ? ' mod2' : '')}
                  >
                    <td>{item.company}</td>
                    <td>
                      {item.stret} {item.house_number}
                    </td>
                    <td>{item.city}</td>
                    <td>
                      <MolLink to={'/konto/address/' + item.adress_id} href="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 576 512"
                          style={{ width: '15px' }}
                        >
                          {/* 
                      <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->*/}
                          <path d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" />
                        </svg>
                      </MolLink>
                    </td>
                    <td>
                      {item.isShippingDefault && item.isBillingDefault ? (
                        <>
                          Standard Versand & <br /> Rechnung
                        </>
                      ) : item.isShippingDefault ? (
                        <>Standard Versand</>
                      ) : item.isBillingDefault ? (
                        <>Standard Rechnung</>
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  {item.department != null ||
                  item.additive1 != null ||
                  item.additive2 != null ? (
                    <tr
                      key={'adress_pos_details' + index}
                      id={'adress_pos_details' + index}
                      className={'row' + (index % 2 == 1 ? ' mod2' : '')}
                    >
                      <td>&nbsp;&nbsp;&nbsp;{item.department}</td>
                      <td>&nbsp;&nbsp;&nbsp;{item.additive1}</td>
                      <td>&nbsp;&nbsp;&nbsp;{item.additive2}</td>
                      <td></td>
                      <td></td>
                    </tr>
                  ) : null}
                </>
              );
            })}
          </tbody>
        </table>

        <br />
        <button
          onClick={() => {
            window.historyHelper.memory.push('/konto/address/new', null);
          }}
        >
          Neue Addresse
        </button>
      </div>
    );
  }
}
